import React from 'react';
import PropTypes from 'prop-types';

import { Helpers } from '../../core/src/helpers';
import Icon from '../../ui/components/icon';

import './compare-box.less';

function CompareBox({ product, toggleCompareProduct }) {
    return (
        <div className="compare-box item">
            <div className="product">
                <div className="action" onClick={() => toggleCompareProduct(product)}>
                    <Icon name="x" size={16} />
                </div>
                <div className="product-container">
                    <img src={product.imageUrl} alt="product" />
                    <div className="name" style={{   WebkitBoxOrient:   'vertical'   }}>
                        {product.name}
                    </div>
                </div>
            </div>
            <div className="price">{Helpers.formatCurrency(product.salePrice, '$')}</div>
        </div>
    );
}

CompareBox.propsTypes = {
    /** product object */
    product: PropTypes.object,
    /** add/remove product from compare set */
    toggleCompareProduct: PropTypes.func,
};

export default CompareBox;
